export default function Tabs({ tabs, selected, onChange }) {
    return (
        <div className="tabs">
            { tabs.map((tab) => (
                <div
                    key={ tab.id }
                    className={ 'tab' + ( selected === tab.id ? ' selected' : '' ) }
                    onClick={ () => onChange(tab.id) }
                >
                    { tab.label }
                </div>
            ))}
        </div>
    );
}
